import * as z from "zod";
import { mutator } from "./mutator";

const deleteEgressRuleSchema = z.object({ id: z.string() });

export const deleteEgressRule = mutator({
  schema: deleteEgressRuleSchema,
  resolve: {
    rule: { kind: "egressRule", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:egress_rules_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { rule } }) => {
    await tx.mutate.egressRules.delete({ id: rule.id });
  },
});
